import { Component, OnInit, AfterViewInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from '@env';
import { KeycloakService } from 'keycloak-angular';

declare const ga: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'app';
  isLoggedIn = false;

  constructor (
    @Inject(DOCUMENT) private document: Document,
    private router: Router , public keycloakService: KeycloakService
  ) { 
    // Google Analytics
    const head: Element = this.document.getElementsByTagName('head')[0];
    if (environment.googleAnalytics) {
      // Add Google Analytics to head the script
      const googleScript = this.document.createElement('script');
      googleScript.type = 'text/javascript';
      googleScript.innerHTML = '(function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){'
        + '(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),'
        + 'm=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)'
        + '})(window,document,\'script\',\'https://www.google-analytics.com/analytics.js\',\'ga\')';
      head.appendChild(googleScript);
  
      ga('create', 'UA-168097033-1');
    }
  }

  async ngOnInit() {
    this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            console.log('here at naviagtion end about to scroll up');
            window.scrollTo(0, 0);
        });

        this.isLoggedIn = await this.keycloakService.isLoggedIn();
  }

  ngAfterViewInit() {
    if (environment.googleAnalytics) {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd ) {
          ga('set', 'page', event.urlAfterRedirects);
          ga('send', 'pageview');
        }
      });
    }
  }


  

  async loginOrLogout() {
    if (this.isLoggedIn) {
      await this.keycloakService.logout('https://ap-tech-solns.com');
      document.cookie ='JWT=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

    } else {
      await this.keycloakService.login({
        redirectUri: 'https://ap-tech-solns.com',
      });

    }
  }

}
